import { CLOUDINARY_UNSIGNED_UPLOAD_PRESET, CLOUDINARY_URL } from 'src/api/cloudinary';

export function uploadToCloudinary(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const formData = new FormData();
    xhr.open('POST', CLOUDINARY_URL, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- JSON.parse returns any; narrow at the boundary
            const response = JSON.parse(xhr.responseText) as { secure_url: string };
            resolve(response.secure_url);
          } catch {
            // A throw here would escape the Promise (we're in an async XHR
            // event), leaving it pending forever and locking the submit button.
            reject(new Error('Image upload failed: unexpected response format'));
          }
        } else {
          reject(new Error('Image upload failed'));
        }
      }
    };

    formData.append('upload_preset', CLOUDINARY_UNSIGNED_UPLOAD_PRESET);
    formData.append('file', file);
    xhr.send(formData);
  });
}
